function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.67,
    height: 9.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2971428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 4.54,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.08,
    width: 24.67,
    height: 9.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 13.695,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.31,
    width: 24.67,
    height: 12.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 24.59,
    fontFamily: "Arial"
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.87,
    width: 24.67,
    height: 21.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.561666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 41.555,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.24,
    width: 24.67,
    height: 26.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 65.36500000000001,
    fontFamily: "Arial"
  }, "\n        Montour\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.49,
    width: 24.67,
    height: 28.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.111666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 92.82499999999999,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.16,
    width: 24.67,
    height: 35.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 124.685,
    fontFamily: "Arial"
  }, "\n        Juniata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.2,
    width: 24.67,
    height: 47.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 165.83999999999997,
    fontFamily: "Arial"
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 189.48,
    width: 24.67,
    height: 48.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 213.73,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.98,
    width: 24.67,
    height: 51.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.111666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 263.94,
    fontFamily: "Arial"
  }, "\n        Snyder\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.91,
    width: 24.67,
    height: 53.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 316.545,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 343.18,
    width: 24.67,
    height: 54.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.223333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 370.63,
    fontFamily: "Arial"
  }, "\n        Elk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 398.08,
    width: 24.67,
    height: 55.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.111666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 425.645,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 453.21,
    width: 24.67,
    height: 59.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 482.755,
    fontFamily: "Arial"
  }, "\n        Mifflin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512.3,
    width: 24.67,
    height: 59.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 542.165,
    fontFamily: "Arial"
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 572.03,
    width: 24.67,
    height: 63.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.111666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 603.98,
    fontFamily: "Arial"
  }, "\n        Mckean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.94,
    width: 24.67,
    height: 64.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.335,
    y: 667.97,
    fontFamily: "Arial"
  }, "\n        Clarion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 0,
    width: 34.04,
    height: 46.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.404
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.69,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Huntingdon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.71,
    y: 0,
    width: 34.28,
    height: 46.76,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.85,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.99,
    y: 0,
    width: 36.84,
    height: 46.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3490909090909096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.41,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Susquehanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.83,
    y: 0,
    width: 37.04,
    height: 46.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.35000000000002,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.87,
    y: 0,
    width: 37.42,
    height: 46.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.236666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.58,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.29,
    y: 0,
    width: 37.49,
    height: 46.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.165555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.035,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.78,
    y: 0,
    width: 40.35,
    height: 46.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.955,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.13,
    y: 0,
    width: 41.46,
    height: 46.76,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.922857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.86,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.59,
    y: 0,
    width: 43.78,
    height: 46.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.47999999999996,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Venango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.36,
    y: 0,
    width: 45.39,
    height: 46.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.055,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Carbon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.75,
    y: 0,
    width: 46.7,
    height: 46.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.1,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.46,
    y: 0,
    width: 49.77,
    height: 46.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.34499999999997,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.22,
    y: 0,
    width: 58.5,
    height: 46.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.195555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.47,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.72,
    y: 0,
    width: 65.29,
    height: 46.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.676
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.365,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Clearfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.02,
    y: 0,
    width: 66.98,
    height: 46.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.51,
    y: 23.38,
    fontFamily: "Arial"
  }, "\n        Indiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 46.76,
    width: 61.45,
    height: 53.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 73.53,
    fontFamily: "Arial"
  }, "\n        Somerset\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 100.3,
    width: 61.45,
    height: 53.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 127.285,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 154.28,
    width: 61.45,
    height: 54.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 181.325,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 208.36,
    width: 61.45,
    height: 54.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.854000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 235.495,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 262.63,
    width: 61.45,
    height: 64.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 294.8,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 326.98,
    width: 61.45,
    height: 70.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 362.03000000000003,
    fontFamily: "Arial"
  }, "\n        Lycoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 397.07,
    width: 61.45,
    height: 73.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.290000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 433.705,
    fontFamily: "Arial"
  }, "\n        Blair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 470.34,
    width: 61.45,
    height: 74.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.778571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 507.575,
    fontFamily: "Arial"
  }, "\n        Lebanon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 544.82,
    width: 61.45,
    height: 76.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.241666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 582.865,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 620.91,
    width: 61.45,
    height: 79.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.241666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.395,
    y: 660.4549999999999,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 46.76,
    width: 60.67,
    height: 80.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.58375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.45500000000001,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.79,
    y: 46.76,
    width: 61.37,
    height: 80.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.767142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.475,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.16,
    y: 46.76,
    width: 61.37,
    height: 80.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.228333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.845,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Centre\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 46.76,
    width: 72.23,
    height: 80.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.223000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.65500000000003,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Schuylkill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.77,
    y: 46.76,
    width: 74.69,
    height: 80.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.115,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Cambria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 46.76,
    width: 87.75,
    height: 80.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.418333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.335,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.2,
    y: 46.76,
    width: 91.18,
    height: 80.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.418333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.79,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Beaver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.38,
    y: 46.76,
    width: 104.62,
    height: 80.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.051
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.69,
    y: 87.015,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 127.28,
    width: 107.71,
    height: 81.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 168.06,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 208.83,
    width: 107.71,
    height: 89.26,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.926
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 253.46,
    fontFamily: "Arial"
  }, "\n        Lackawanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 298.09,
    width: 107.71,
    height: 93.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.317142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 344.7,
    fontFamily: "Arial"
  }, "\n        Dauphin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 391.32,
    width: 107.71,
    height: 96.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.814545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 439.8,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 488.27,
    width: 107.71,
    height: 104.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 540.29,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.12,
    y: 592.31,
    width: 107.71,
    height: 107.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.948333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.975,
    y: 646.155,
    fontFamily: "Arial"
  }, "\n        Lehigh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.83,
    y: 127.28,
    width: 108.93,
    height: 109.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.561428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.29500000000002,
    y: 182.035,
    fontFamily: "Arial"
  }, "\n        Luzerne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.76,
    y: 127.28,
    width: 123.12,
    height: 109.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.902
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.32,
    y: 182.035,
    fontFamily: "Arial"
  }, "\n        Berks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.87,
    y: 127.28,
    width: 131.39,
    height: 109.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.565,
    y: 182.035,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.26,
    y: 127.28,
    width: 142.74,
    height: 109.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.125833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.63,
    y: 182.035,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.83,
    y: 236.79,
    width: 131.57,
    height: 132.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.618888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.615,
    y: 303.25,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.83,
    y: 369.71,
    width: 131.57,
    height: 142.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.795714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.615,
    y: 440.80999999999995,
    fontFamily: "Arial"
  }, "\n        Chester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.83,
    y: 511.91,
    width: 131.57,
    height: 188.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.615,
    y: 605.955,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.4,
    y: 236.79,
    width: 165.61,
    height: 158.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.733999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.205,
    y: 316.125,
    fontFamily: "Arial"
  }, "\n        Bucks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.01,
    y: 236.79,
    width: 208.99,
    height: 158.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.866999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.505,
    y: 316.125,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.4,
    y: 395.46,
    width: 183.81,
    height: 304.54,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.30499999999995,
    y: 547.73,
    fontFamily: "Arial"
  }, "\n        Philadelphia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.21,
    y: 395.46,
    width: 190.79,
    height: 304.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.198888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.605,
    y: 547.73,
    fontFamily: "Arial"
  }, "\n        Allegheny\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.d087a3961f84a3e822676d57ddf33d96.svg";
export { ForwardRef as ReactComponent };